import React from 'react';
import {
  MuiPickersUtilsProvider,
  TimePicker,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/moment';

import { createTheme } from '@material-ui/core';
import { ThemeProvider } from '@material-ui/styles';
import TimeIcon from '@material-ui/icons/AccessTime';

import styles from '../atoms/ACDateTimeRange.module.scss';

const materialTheme = createTheme({
  overrides: {
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: '#52A8EF',
      },
    },
  },
});

export default class ACDateTimeRange extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.onChangeFromTime = this.onChangeFromTime.bind(this);
    this.onChangeToTime = this.onChangeToTime.bind(this);

    this.onChangeFromDate = this.onChangeFromDate.bind(this);
    this.onChangeToDate = this.onChangeToDate.bind(this);
  }

  onChangeFromTime(value) {
    this.props.onChangeTimeFunc(this.props.day, 'from', value);
  }

  onChangeToTime(value) {
    this.props.onChangeTimeFunc(this.props.day, 'to', value);
  }

  onChangeFromDate(value) {
    this.props.onChangeDateFunc('from', value);
  }

  onChangeToDate(value) {
    this.props.onChangeDateFunc('to', value);
  }

  renderFromDate(type, value) {
    switch (type) {
      case 'TimePicker':
        return (
          <TimePicker
            variant="inline"
            label="Inline mode"
            value={value}
            onChange={this.onChangeFromTime}
            className={this.props.classNameFrom}
          />
        );
      case 'KeyboardTimePicker':
        return (
          <KeyboardTimePicker
            ampm={this.props.ampm}
            variant="inline"
            label=""
            value={value}
            onChange={this.onChangeFromTime}
            format={this.props.format}
            className={this.props.classNameFrom}
            KeyboardButtonProps={{
              className: this.props.classNameFromIcon,
            }}
            autoOk={true}
            keyboardIcon={<TimeIcon />}
          />
        );
      case 'KeyboardDatePicker':
        return (
          <KeyboardDatePicker
            value={value}
            onChange={this.onChangeFromDate}
            format={this.props.format}
            className={this.props.classNameFrom}
            KeyboardButtonProps={{
              className: this.props.classNameFromIcon,
            }}
            autoOk={true}
          />
        );
      default:
        return <div />;
    }
  }

  renderToDate(type, value) {
    switch (type) {
      case 'TimePicker':
        return (
          <TimePicker
            variant="inline"
            label="Inline mode"
            value={value}
            onChange={this.onChangeToTime}
            className={this.props.classNameTo}
          />
        );
      case 'KeyboardTimePicker':
        return (
          <KeyboardTimePicker
            ampm={this.props.ampm}
            variant="inline"
            label=""
            value={value}
            onChange={this.onChangeToTime}
            format={this.props.format}
            className={this.props.classNameTo}
            KeyboardButtonProps={{
              className: this.props.classNameToIcon,
            }}
            autoOk={true}
            keyboardIcon={<TimeIcon />}
          />
        );
      case 'KeyboardDatePicker':
        return (
          <KeyboardDatePicker
            value={value}
            onChange={this.onChangeToDate}
            format={this.props.format}
            className={this.props.classNameTo}
            KeyboardButtonProps={{
              className: this.props.classNameToIcon,
            }}
            autoOk={true}
          />
        );
      default:
        return <div />;
    }
  }

  render() {
    const { from, to, type } = this.props;

    return (
      <div className={styles.root}>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <ThemeProvider theme={materialTheme}>
            {this.renderFromDate(type, from)}
            <div className={styles.swapIcon}>-</div>
            {this.renderToDate(type, to)}
          </ThemeProvider>
        </MuiPickersUtilsProvider>
      </div>
    );
  }
}
